import { randomUUID } from 'uncrypto'
import { useDayjs, useCookie } from '#imports'

export const useVisitorIdCookie = () => {
    const dayjs = useDayjs()
    const visitorIdCookie = useCookie('_ctvisitor', {
        sameSite: 'lax',
        maxAge: dayjs.duration({ years: 1 }).asSeconds(),
        path: '/',
        secure: true,
        httpOnly: false,
    })

    function setVisitorIdCookie() {
        if (visitorIdCookie.value) return

        visitorIdCookie.value = randomUUID()
    }

    return {
        visitorIdCookie,
        setVisitorIdCookie,
    }
}
